let loadPromise;

const DEFAULT_CONFIG = {
  attribution: 'housinganywhere.com',
  env: 'prod',
  language: 'en',
};

const getTilesUrl = key =>
  `https://maps{s}.a-cdn.net/tiles/${key}/{z}/{x}/{y}.png`;

const VERSION = '3.34.6';

export default ({ key, ...restConfig }) => {
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      return reject(new Error('map cannot be loaded outside browser env'));
    }

    // eslint-disable-next-line no-underscore-dangle
    global.__MAPS_SERVICES_CONFIG__ = {
      ...DEFAULT_CONFIG,
      consumerKey: key,
      tilesUrlTemplate: getTilesUrl(key),
      ...restConfig,
    };

    return import(
      /* webpackChunkName: "pepita-maps" */ 'vendor/maps-migrate.umd'
    )
      .then(maps => ({ ...maps, version: VERSION }))
      .then(resolve);
  });

  return loadPromise;
};
